import * as React from "react"
import { TabList, Tab, VStack, Container, Box } from "@chakra-ui/react"
import { ServicesTabListProps } from "./services-tab-list.interface"
import { CollapseButton } from "../../common/collapse-button"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"

import layoutStates from "../../../recoil/atoms/layout"
import { newReplyAtom } from "../../../recoil/atoms/chats"
import { serviceTabAtom } from "../../../recoil/atoms/service-panele-tab"
import { isToastActiveAtom } from "../../../recoil/atoms/collapseButton"
import { isShowsGridViewSupportedSelector } from "../../../recoil/atoms/room"
import { SHOW_DESKTOP_TAB_INDEX } from "../../../constants"

const BoxTag = React.memo(({ children }) => (
  <Container p="0" centerContent>
    {children}
  </Container>
))

const BoxText = React.memo(({ text }: { text: string }) => {
  return (
    <Container
      p="0"
      centerContent
      fontSize={text.length > 9 ? "11px" : "13px"}
      marginTop="0.2rem !important"
      marginBottom="0.1rem !important"
      lineHeight={1}
      fontWeight="medium"
    >
      {text}
    </Container>
  )
})

export const _ServicesTabList: React.FC<ServicesTabListProps> = ({
  tabButtonStyle,
  setSidebarOpen,
  tabList,
  sidebarOpen,
  showCollapseButton
}) => {
  const [activeTabName, setActiveTabName] = useRecoilState(serviceTabAtom)
  const setChatTab = useSetRecoilState(layoutStates.isChatTab)

  const isToastActive = useRecoilValue(isToastActiveAtom)
  const setNewReply = useSetRecoilState(newReplyAtom)

  const isShowsGridViewSupported = useRecoilValue(
    isShowsGridViewSupportedSelector
  )
  const [targetTabIndex] = useRecoilState<number>(
    layoutStates.historyTabEnabled
  )
  const isShowTabActive =
    targetTabIndex === SHOW_DESKTOP_TAB_INDEX && isShowsGridViewSupported


  const handleOnClick = React.useCallback(({ text, callback }) => {
    setActiveTabName(text)
    setNewReply(null)

    if (callback) callback()

    // Toggle the tab to open if the active tab is closed.
    if (activeTabName === text) {
      setSidebarOpen(prev => !prev)
    } else {
      setSidebarOpen(true)
    }
  }, [activeTabName])

  const handleTab = React.useCallback(
    el => {
      handleOnClick(el)
      setChatTab(false)
    },
    [handleOnClick, setChatTab]
  )

  const collapseButtonHandle = React.useCallback(
    (state: boolean) => {
      setSidebarOpen(state)
      if (activeTabName === "Chat") {
        setChatTab(state)
      }
    },
    [activeTabName, setChatTab, setSidebarOpen]
  )

  return (
    <TabList
      overflowY="auto"
      zIndex="overlay"
      textColor="gray.500"
      bg={tabButtonStyle.background}
      width="75px"
      border="0"
      className="hide-scrollbar"
    >
      {tabList.map((el, index) => {
        if (el.render) {
          return (
            <React.Fragment key={index}>
              {el.text === "Users"
                ? el.render({ index, el, handleOnClick: handleTab, tabButtonStyle })
                : el.render({ index, el, handleOnClick, tabButtonStyle })}
            </React.Fragment>
          )
        }

        return (
          <Box key={index}>
            <Tab
              onClick={() => {
                handleTab(el)
              }}
              {...tabButtonStyle}
              bg="transparent"
              width={"100%"}
              {...el?.customStyles}
            >
              <VStack margin="4px 0px">
                <BoxTag>{el.icon}</BoxTag>
                <BoxText text={el.text} />
              </VStack>
            </Tab>
          </Box>
        )
      })}
      {showCollapseButton && !isToastActive && (
        <CollapseButton
          setSidebarOpen={collapseButtonHandle}
          sidebarOpen={sidebarOpen}
          tabButtonStyle={tabButtonStyle}
          disabled={isShowTabActive}
        />
      )}
    </TabList>
  )
}

export const ServicesTabList = React.memo(_ServicesTabList)
